/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/indent */
import { batch } from '@preact/signals-react'
import { type FormInstance } from 'antd/lib'

import { encryptData } from '@/helpers'
import offlineDB from '@/indexeddb'
import {
  EFormEntityType,
  type TApplication,
  type EFormTableMode,
  type TEntityInfo,
} from '@/interfaces'
import { ApplicationsState, FormState } from '@/state'

import { setSimpleEntityInitialValues } from '../applications/utils'

import formRequests from './requests'
import { setPermisionsToForm } from './utils'

export const formStateActions = {
  changeFormInstanceByEntity: () => {
    FormState.currentFormInstance.peek()?.resetFields()
    FormState.currentFormInstance.peek()?.setFieldsValue({})
  },
  cleanFormState: () => {
    batch(() => {
      FormState.currentEntity.value = null
      FormState.entityForm.value = {
        form: [],
        mode: null,
        openDrawer: false,
        values: {},
      }
      FormState.fileViewer.value = {
        ...FormState.fileViewer.peek(),
        openModal: false,
      }
      FormState.showForm.value = false
      FormState.currentFormValues.value = {}
    })
  },
  closeFileViewer: () => {
    FormState.fileViewer.value = {
      fileBase64String: null,
      isImage: false,
      isPdf: false,
      openModal: false,
    }
  },
  closeSubsectionForm: () => {
    FormState.entityForm.value = {
      form: [],
      mode: null,
      openDrawer: false,
      values: {},
    }
  },
  // TODO: Retorna todas las entidades desde espoCRM y setea los permisos de edición en los formularios
  getCurrentForm: async () => {
    const currentFormData = await formRequests.getCurrentForm()
    FormState.currentForm.value = currentFormData.data

    // Buscar la entidad principal (usualmente la primera con permiso de lectura)
    const mainEntity = currentFormData.data.find(entity => entity.permission?.read)
    let entityId = null
    if (mainEntity && mainEntity.sections && mainEntity.sections.length > 0) {
      for (const section of mainEntity.sections) {
        const idField = section.fields?.find(f => f.name === 'id')
        if (idField && idField.default) {
          entityId = idField.default
          break
        }
      }
    }
    // Sincronizar el id en el estado global
    if (entityId) {
      ApplicationsState.currentApplication.value = {
        ...ApplicationsState.currentApplication.peek(),
        id: entityId
      }
    }

    await offlineDB.saveMultipleToStore(offlineDB.stores.USER_STORE, [
      {
        data: encryptData(JSON.stringify(currentFormData.data)),
        id: offlineDB.userStoreIds.formEntities,
      },
    ])

    setPermisionsToForm()
  },
  hideForm: () => {
    FormState.showForm.value = false
  },
  openSubsectionForm: (mode: EFormTableMode, values?: TApplication) => {
    const entityForm =
      (FormState.currentEntity.value?.sections ?? [])[0]?.fields ?? []

    let defaultValues = values ?? {}

    if (defaultValues) {
      defaultValues = setSimpleEntityInitialValues(
        defaultValues,
        FormState.currentEntity.value?.sections ?? []
      )
    }

    FormState.entityForm.value = {
      form: entityForm,
      mode,
      openDrawer: true,
      values: { id: values?.id, ...defaultValues },
    }
  },
  setCurrentEntity: (entity?: TEntityInfo) => {
    let currentEntity = entity

    if (!currentEntity) {
      currentEntity = FormState.currentForm
        .peek()
        .filter((entity) => entity.permission?.read)[0]
    }

    if (currentEntity?.type === EFormEntityType.TABLE) {
      const entityName = currentEntity.name
      const currentApplicationValues =
        ApplicationsState.currentApplication.peek()

      if (entityName && currentApplicationValues) {
        const currentEntityValues = currentApplicationValues[
          entityName
        ] as TApplication[]

        ApplicationsState.currentEntityTableData.value = [
          ...currentEntityValues,
        ]
      }
    }
    FormState.hasRequiredFieldsEmpty.value = false
    FormState.currentEntity.value = { ...currentEntity }
    FormState.entityForm.value = {
      ...FormState.entityForm.peek(),
      mode: null,
      openDrawer: false,
    }
    FormState.currentEntityDateFields.value = []
    ApplicationsState.currentEntityFilesData.value = {}
  },
  setCurrentForm: async (formData: TEntityInfo[]) => {
    FormState.currentForm.value = formData

    await offlineDB.saveMultipleToStore(offlineDB.stores.USER_STORE, [
      {
        data: encryptData(JSON.stringify(formData)),
        id: offlineDB.userStoreIds.formEntities,
      },
    ])

    setPermisionsToForm()
  },
  setCurrentFormInstance: (formInstance: FormInstance | null) => {
    FormState.currentFormInstance.value = formInstance
  },
  showForm: () => {
    FormState.showForm.value = true
  },
  toggleShowForm: () => {
    FormState.showForm.value = !FormState.showForm.peek()
  },
  viewFile: async (fileString: string) => {
    const isPdf = fileString.includes('data:application/pdf')
    const isImage = fileString.includes('data:image')

    FormState.fileViewer.value = {
      fileBase64String: fileString,
      isImage,
      isPdf,
      openModal: true,
    }
  },
}
